import { view } from 'ramda';
import {
  isSamsClub,
  promotionDisplayNameLens,
  promotionIdLens,
  promotionCodeLens,
  redemptionCodeLens,
  entityLogoLens,
  promoCodeLens,
  redemptionUrlLens,
  promotionHasNoneCodeType,
} from '../../data';
import { formatPromotionForEventStream } from '../../eventstream';

export const createPresenter = (promo, moveId) => {
  /***
    temporary for now
    sourceId = 7 is for FYM Offers page
  ***/
  const sourceId = 7;

  const eligiblePromotion = promo.__typename === 'EligiblePromotion';
  const claimedId = !eligiblePromotion ? promo.id : null;
  const code = view(promotionCodeLens, promo);
  const discountCode = { __html: view(promoCodeLens, promo) };
  const name = eligiblePromotion
    ? promo.validFor[0].name
    : promo.claimedFor.name;
  const displayName = view(promotionDisplayNameLens, promo);
  const promotionId = view(promotionIdLens, promo);
  const entityId = eligiblePromotion
    ? promo.validFor[0].id
    : promo.claimedFor.id;
  const entityLogo = view(entityLogoLens, promo);
  const promotion = eligiblePromotion
    ? formatPromotionForEventStream(promo.promotion, promo.validFor[0])
    : null;
  const selected = promo.selected;
  const promotionCode = eligiblePromotion
    ? view(promotionCodeLens, promo)
    : view(redemptionCodeLens, promo);
  const redemptionUrl = isSamsClub(promo)
    ? `${view(
        redemptionUrlLens,
        promo
      )}?sourceId=${sourceId}&moveId=${moveId}&pid=${promotionId}&eid=${entityId}`
    : view(redemptionUrlLens, promo);
  const hasNoPromotionCode = promotionHasNoneCodeType(promo);
  const redemptionMsg = !eligiblePromotion
    ? hasNoPromotionCode
      ? 'Discount will be automatically applied at checkout.'
      : 'Your unique code:'
    : '';
  const showCode = !eligiblePromotion && !hasNoPromotionCode;
  const showNoCode = !eligiblePromotion && hasNoPromotionCode;
  const showGoBtn = !eligiblePromotion && hasNoPromotionCode;
  const showCopyGoBtn = !eligiblePromotion && !hasNoPromotionCode;

  return {
    code,
    name,
    claimedId,
    displayName,
    discountCode,
    selected,
    entityId,
    entityLogo,
    promotion,
    promotionId,
    promotionCode,
    eligiblePromotion,
    redemptionUrl,
    redemptionMsg,
    showCode,
    showNoCode,
    showGoBtn,
    showCopyGoBtn,
  };
};
